export const SET_PETS = 'SET_PETS'
export const SET_CURRENT_PETS = 'SET_CURRENT_PETS'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_LOADING = 'SET_LOADING'
export const SET_FILTERS = 'SET_FILTERS'
export const FILTER_PETS = 'FILTER_PETS'
export const SET_POST_PER_PAGE = 'SET_POST_PER_PAGE'
